import { Container } from "react-bootstrap"
import HeroBio from "../../bio_components/heroBio/components/heroBio"
import TextContentBio from "../../bio_components/textContentBio/components/textContentBio"

const Bio = ()=>{
    return (
        <Container fluid className="p-0 m-0">
            <HeroBio/>
            <TextContentBio/>
        </Container>
    )
}
export default Bio